import BaseModel from './BaseModel';
import ReviewMember from './ReviewMember';
import Reference from './Reference';

export default class Comment extends BaseModel {
  constructor(data = {}) {
    super(Comment, data);
    this.id = data.id;
    this.text = data.text;
    this.reviewer = data.reviewer && new ReviewMember(data.reviewer);
    this.reference = data.reference && new Reference(data.reference);
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }
}
